import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Cookie } from 'lucide-react';

export default function CookiePolicy() {
    useEffect(() => {
        // Load Iubenda script if not already present
        const scriptId = 'iubenda-js';
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.type = 'text/javascript';
            script.src = 'https://cdn.iubenda.com/iubenda.js';
            document.body.appendChild(script);
        }

        // Restart Iubenda loader to find the new embed link
        if (window.Iubenda && window.Iubenda.loader) {
            window.Iubenda.loader.restart();
        }
    }, []);

    return (
        <div className="min-h-screen bg-white pt-32 pb-20">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-center mb-16"
                >
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-6">
                        <Cookie className="w-8 h-8 text-blue-600" />
                    </div>
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">Cookie Policy</h1>
                    <p className="text-lg text-gray-600">
                        In questa pagina puoi consultare l'informativa estesa sull'uso dei cookie.
                    </p>
                </motion.div>

                {/* Content Container */}
                <div className="bg-white p-8 rounded-3xl border border-gray-100 shadow-sm text-gray-700">
                    <div dangerouslySetInnerHTML={{
                        __html: `
                        <div class="container">
                            <header class="main-header">
                                <h1 class="text-3xl font-bold mb-4">Cookie Policy di <strong>www.tecnosys-ups.com</strong></h1>
                                <p class="mb-4">Benvenuto nella cookie policy di www.tecnosys-ups.com. Questa policy ti aiuterà a comprendere quali cookie e tecnologie di tracciamento utilizziamo, come li utilizziamo e quali sono i tuoi diritti in merito.</p>
                                <p class="text-sm text-gray-500">Ultima modifica: 26 gennaio 2026</p>
                            </header>

                            <main class="mt-12 space-y-12">
                                <section class="main__section section__introduction">
                                    <h2 id="introduction" class="text-2xl font-bold mb-4">Introduzione</h2>
                                    <p class="mb-4 leading-relaxed">
                                        Questo documento contiene informazioni in merito alle tecnologie che consentono a questa Applicazione di raggiungere gli scopi descritti di seguito. Tali tecnologie permettono al Titolare di raccogliere e salvare informazioni (per esempio tramite l’utilizzo di Cookie) o di utilizzare risorse (per esempio eseguendo uno script) sul dispositivo dell’Utente quando quest’ultimo interagisce con questa Applicazione.
                                    </p>
                                    <p class="leading-relaxed">
                                        Per semplicità, in questo documento tali tecnologie sono sinteticamente definite “Strumenti di Tracciamento”, salvo vi sia ragione di differenziare.
                                    </p>
                                </section>

                                <section class="main__section section__owner-and-data-controller">
                                    <h2 id="owner-and-data-controller" class="text-2xl font-bold mb-4">Titolare del Trattamento dei Dati</h2> 
                                    <p class="mb-2"><strong>Tecnosys di Lo Verso Salvatore</strong><br>via A. Cesalpino, 7 - 90128<br>Palermo</p>
                                    <p><strong>Indirizzo email del Titolare:</strong> info@tecnosys-ups.com</p>
                                </section>

                                <section class="main__section section__trackers-usage">
                                    <h2 id="trackers-usage" class="text-2xl font-bold mb-4">Come questa Applicazione utilizza gli Strumenti di Tracciamento</h2>
                                    
                                    <h3 class="text-xl font-bold mb-2">Necessari</h3>
                                    <p class="mb-6">Questa Applicazione utilizza Cookie comunemente detti “tecnici” o altri Strumenti di Tracciamento analoghi per svolgere attività strettamente necessarie a garantire il funzionamento o la fornitura del Servizio.</p>

                                    <h3 class="text-xl font-bold mb-2">Funzionalità</h3>
                                    <p class="mb-4">Questa Applicazione utilizza Strumenti di Tracciamento per consentire semplici interazioni e attivare funzionalità che permettono agli Utenti di accedere a determinate risorse del Servizio e semplificano la comunicazione con il Titolare.</p>

                                    <div class="bg-gray-50 p-6 rounded-2xl border border-gray-200">
                                        <h4 class="font-bold mb-2">WhatsApp Business Chat Widget</h4>
                                        <p class="text-sm text-gray-600 mb-2">Meta Platforms, Inc. (Stati Uniti)</p>
                                        <p class="text-sm italic">Dati trattati: numero di telefono, contenuti del messaggio, dati di utilizzo.</p>
                                    </div>
                                </section>

                                <section class="main__section section__manage-preferences">
                                    <h2 id="manage-preferences" class="text-2xl font-bold mb-4">Come gestire le preferenze</h2>
                                    <p class="mb-4 leading-relaxed">
                                        Qualora l’utilizzo dei Tracker sia basato sul consenso, l’Utente può fornire o revocare tale consenso impostando o aggiornando le proprie preferenze tramite il relativo pannello delle scelte in materia di privacy disponibile su questa Applicazione.
                                    </p>
                                    <p class="leading-relaxed">
                                        Gli Utenti possono inoltre utilizzare le impostazioni del proprio browser per gestire, bloccare o cancellare i Cookie sul proprio dispositivo.
                                    </p>
                                </section>

                                <section class="main__section section__legal">
                                    <h2 id="definitions_and_legal_references" class="text-2xl font-bold mb-4">Definizioni e riferimenti legali</h2>
                                    <p class="text-sm leading-relaxed">
                                        Costituisce dato personale qualunque informazione che, direttamente o indirettamente, renda identificata o identificabile una persona fisica. Strumento di Tracciamento s’intende qualsiasi tecnologia che consenta di tracciare gli Utenti, raccogliendo o salvando informazioni sul dispositivo dell’Utente.
                                    </p>
                                </section>
                            </main>

                            <footer class="mt-16 pt-8 border-t border-gray-200 text-center">
                                <p class="text-xs text-gray-400">
                                    Generato con <strong>Iubenda</strong>. Questo documento riguarda esclusivamente questa Applicazione.
                                </p>
                            </footer>
                        </div>
                    ` }} />
                </div>
            </div>
        </div>
    );
}
